const auditLogSelectors = function() {
  const self = {};

  const _select = function(state) {
    return state.aesTools.auditLog;
  };

  self.selectList = function(state) {
    const root = _select(state);

    return Object.assign({}, root.list);
  };

  self.selectCurrent = function(state) {
    const root = _select(state);

    return Object.assign({}, root.current);
  };

  self.selectRelated = function(state) {
    const root = _select(state);

    return Object.assign({}, root.related);
  };

  self.selectPrevious = function(state) {
    const root = _select(state);
    const before = root.related.before.list;

    if (!before) return null;
    if (before.length == 0) return null;

    return Object.assign({}, before[0]);
  };

  self.selectSubjects = function(state) {
    const root = _select(state);

    return root.subjects;
  };

  self.selectActions = function(state) {
    const root = _select(state);

    return root.actions;
  };

  self.selectClients = function(state) {
    const root = _select(state);

    return root.clients.clients;
  };

  self.selectUsers = function(state) {
    const root = _select(state);

    return root.users.users;
  };


  self.selectListAudits = function(state) {
    const list = self.selectList(state);

    return list.results;
  };

  self.selectListCount = function(state) {
    const list = self.selectList(state);

    return list.count;
  };

  self.selectListLimit = function(state) {
    const list = self.selectList(state);

    return list.limit;
  };

  self.selectListPage = function(state) {
    const list = self.selectList(state);

    return list.page;
  };

  self.selectListLoading = function(state) {
    const list = self.selectList(state);

    return list.loading;
  };

  self.selectCurrentLoading = function(state) {
    const current = self.selectCurrent(state);

    return current.loading;
  };


  return self;
};

export default auditLogSelectors();
